import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@mui/material/Link'

export const MuiRouterLink = React.forwardRef((props, ref) => {
  return <Link component={RouterLink} ref={ref} {...props} />
});